// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faPlus,
//   faCalendarAlt,
//   faFileAlt,
//   faHourglassHalf,
//   faCheckCircle,
//   faTimesCircle,
// } from "@fortawesome/free-solid-svg-icons";
// import {
//   Box,
//   Typography,
//   Button,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   TableContainer,
//   CircularProgress,
//   Grid,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import CheckIcon from "@mui/icons-material/Check";
// import CloseIcon from "@mui/icons-material/Close";
// import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

// import Navbar from "../common/Navbar";
// import Footer from "../common/Footer";
// import Sidebar from "../common/Sidebar";

// import {
//   FaBriefcase,
//   FaHeartbeat,
//   FaUmbrellaBeach,
//   FaPlaneDeparture,
// } from "react-icons/fa";
// const LeaveRequestsList = () => {
//   const [leaveRequests, setLeaveRequests] = useState([]);
//   const [remainingLeaves, setRemainingLeaves] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       setError("");
//       try {
//         const token = sessionStorage.getItem("token");
//         if (!token) {
//           setError("User not authenticated");
//           return;
//         }

//         const leaveRes = await fetch(
//           `${process.env.REACT_APP_BASE_URL}/api/leave/getleaverequest`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         const leaveData = await leaveRes.json();
//         if (!leaveRes.ok) throw new Error(leaveData.message);
//         setLeaveRequests(leaveData);

//         const remRes = await fetch(
//           `${process.env.REACT_APP_BASE_URL}/api/employees/leaves/remainingleaves`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         const remData = await remRes.json();
//         if (!remRes.ok) throw new Error(remData.message);
//         setRemainingLeaves(remData);
//       } catch (err) {
//         setError(err.message || "Something went wrong");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   const calculateLeaveDays = (startDate, endDate) => {
//     const start = new Date(startDate);
//     const end = new Date(endDate);
//     const diffTime = Math.abs(end - start);
//     const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
//     return diffDays;
//   };

//   const leaveIcons = {
//     annualleave: <CalendarMonthOutlinedIcon fontSize="inherit" />,
//     sickleave: <CalendarMonthOutlinedIcon fontSize="inherit" />,
//     casualleave: <CalendarMonthOutlinedIcon fontSize="inherit" />,
//     other: <CalendarMonthOutlinedIcon fontSize="inherit" />,
//     default: <CalendarMonthOutlinedIcon fontSize="inherit" />,
//   };
//   const formatDate = (date) =>
//     new Date(date).toLocaleDateString(undefined, {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });

//   const getStatusIcon = (status) => {
//     switch (status?.toLowerCase()) {
//       case "approved":
//         return (
//           <FontAwesomeIcon icon={faCheckCircle} style={{ color: "#2ecc71" }} />
//         );
//       case "rejected":
//         return (
//           <FontAwesomeIcon icon={faTimesCircle} style={{ color: "#e74c3c" }} />
//         );
//       default:
//         return (
//           <FontAwesomeIcon
//             icon={faHourglassHalf}
//             style={{ color: "#f39c12" }}
//           />
//         );
//     }
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         minHeight: "100vh",
//         bgcolor: "#f5f7fa",
//       }}
//     >
//       <Navbar />
//       <Box sx={{ display: "flex", flex: 1 }}>
//         <Sidebar />
//         <Box component="main" sx={{ flex: 1, p: 2, ml: { sm: 0, md: 2 } }}>
//           {/* 1. Header */}
//           <Box
//             sx={{
//               maxWidth: "1100px",
//               mx: "auto",
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               mt: { xs: 6, md: 8 },
//               mb: 4,
//             }}
//           >
//             <Box sx={{ flexGrow: 1 }}>
//               <Typography
//                 variant="h4"
//                 fontWeight="bold"
//                 sx={{ color: "#0f172a" }}
//               >
//                 My Leave Requests
//               </Typography>
//               <Typography variant="body2" sx={{ color: "#64748b" }}>
//                 Apply for leave and track your requests
//               </Typography>
//             </Box>

//             {/* Apply Leave Button */}
//             <Box sx={{ flexShrink: 0 }}>
//               <button
//                 onClick={() => navigate("/ApplyForLeave")}
//                 style={{
//                   backgroundColor: "#000",
//                   color: "#fff",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   padding: "6px 14px",
//                   borderRadius: "6px",
//                   border: "none",
//                   cursor: "pointer",
//                   fontWeight: 600,
//                   fontSize: "14px",
//                   transition: "all 0.2s ease-in-out",
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.backgroundColor = "#1f2937";
//                   e.currentTarget.style.transform = "scale(1.03)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.backgroundColor = "#000";
//                   e.currentTarget.style.transform = "scale(1)";
//                 }}
//               >
//                 <FontAwesomeIcon icon={faPlus} style={{ marginRight: "6px" }} />
//                 {!isMobile && "Apply Leave"}
//               </button>
//             </Box>
//           </Box>

//           {remainingLeaves && (
//             <Box sx={{ maxWidth: "1100px", mx: "auto", mb: 4 }}>
//               <Typography variant="h6" fontWeight={600} mb={0.5}>
//                 Remaining Leaves
//               </Typography>

//               <Grid container spacing={2}>
//                 {Object.entries(remainingLeaves.remainingLeave || {}).map(
//                   ([type, count]) => {
//                     const icon =
//                       leaveIcons[type.toLowerCase()] || leaveIcons.default;

//                     return (
//                       <Grid item xs={12} sm={6} md={3} key={type}>
//                         <Paper
//                           sx={{
//                             p: 2,
//                             borderRadius: 2,
//                             boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
//                             transition: "all 0.2s ease",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "space-between",
//                             "&:hover": {
//                               boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//                               transform: "translateY(-2px)",
//                             },
//                           }}
//                         >
//                           <Box>
//                             <Typography
//                               variant="subtitle2"
//                               color="#2c3e50"
//                               fontWeight={500}
//                             >
//                               {type
//                                 .replace(/([a-z])([A-Z])/g, "$1 $2")
//                                 .replace(/^./, (str) => str.toUpperCase())}
//                             </Typography>
//                             <Typography variant="h5" fontWeight="bold">
//                               {count}
//                             </Typography>
//                             <Typography variant="body2" color="text.secondary">
//                               days available
//                             </Typography>
//                           </Box>

//                           <Box sx={{ color: "#2563eb", fontSize: "35px" }}>
//                             {icon}
//                           </Box>
//                         </Paper>
//                       </Grid>
//                     );
//                   }
//                 )}
//               </Grid>
//             </Box>
//           )}

//           <Paper
//             elevation={0}
//             sx={{
//               borderRadius: 3,
//               boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
//               p: 3,
//             }}
//           >
//             <Typography variant="h6" fontWeight={600} gutterBottom>
//               Leave Requests
//             </Typography>
//             <Typography variant="body2" color="text.secondary" mb={3}>
//               Manage leave requests from your team
//             </Typography>

//             <Box
//               sx={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr 1fr 1fr 1fr",
//                 color: "#475569",
//                 fontWeight: 600,
//                 fontSize: "14px",
//                 px: 1,
//                 mb: 1,
//               }}
//             >
//               <Box>Type</Box>
//               <Box>Period</Box>
//               <Box>Days</Box>
//               <Box>Status</Box>
//             </Box>

//             {leaveRequests.map((req, index) => (
//               <Box
//                 key={req._id}
//                 sx={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr 1fr 1fr",
//                   alignItems: "center",
//                   px: 1,
//                   py: 1.25,
//                   borderRadius: 2,
//                   backgroundColor: "#fff",
//                   transition: "background 0.2s",
//                   borderBottom:
//                     index !== leaveRequests.length - 1
//                       ? "1px solid #e5e7eb"
//                       : "none",
//                   "&:hover": {
//                     backgroundColor: "#f9fafb",
//                   },
//                 }}
//               >
//                 <Typography
//                   variant="body2"
//                   fontWeight={500}
//                   fontSize="14px"
//                   sx={{ textTransform: "capitalize" }}
//                 >
//                   {req.leaveType}
//                 </Typography>

//                 <Box>
//                   <Typography variant="body2" fontWeight={500} fontSize="14px">
//                     {formatDate(req.startDate)}
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     to {formatDate(req.endDate)}
//                   </Typography>
//                 </Box>

//                 <Typography fontSize="14px">
//                   {calculateLeaveDays(req.startDate, req.endDate)}
//                 </Typography>

//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   {getStatusIcon(req.status)}
//                   <Box
//                     sx={{
//                       backgroundColor:
//                         req.status === "approved"
//                           ? "#d1fae5"
//                           : req.status === "rejected"
//                           ? "#fee2e2"
//                           : "#fef9c3",
//                       color:
//                         req.status === "approved"
//                           ? "#065f46"
//                           : req.status === "rejected"
//                           ? "#991b1b"
//                           : "#92400e",
//                       px: 1.5,
//                       py: 0.3,
//                       borderRadius: "999px",
//                       fontSize: "13px",
//                       fontWeight: 500,
//                       textTransform: "capitalize",
//                       boxShadow: "0px 1px 2px rgba(0,0,0,0.05)",
//                     }}
//                   >
//                     {req.status || "pending"}
//                   </Box>
//                 </Box>
//               </Box>
//             ))}
//           </Paper>
//         </Box>
//       </Box>
//       <Footer />
//     </Box>
//   );
// };

// export default LeaveRequestsList;




import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faCalendarAlt,
  faFileAlt,
  faHourglassHalf,
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  Box,
  Typography,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  CircularProgress,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import Sidebar from "../common/Sidebar";

import {
  FaBriefcase,
  FaHeartbeat,
  FaUmbrellaBeach,
  FaPlaneDeparture,
} from "react-icons/fa";
const LeaveRequestsList = () => {
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [remainingLeaves, setRemainingLeaves] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError("");
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          setError("User not authenticated");
          return;
        }

        const leaveRes = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/leave/getleaverequest`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const leaveData = await leaveRes.json();
        if (!leaveRes.ok) throw new Error(leaveData.message);
        setLeaveRequests(leaveData);

        const remRes = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/employees/leaves/remainingleaves`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const remData = await remRes.json();
        if (!remRes.ok) throw new Error(remData.message);
        setRemainingLeaves(remData);
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const calculateLeaveDays = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return diffDays;
  };

  const leaveIcons = {
    annualleave: <CalendarMonthOutlinedIcon fontSize="inherit" />,
    sickleave: <CalendarMonthOutlinedIcon fontSize="inherit" />,
    casualleave: <CalendarMonthOutlinedIcon fontSize="inherit" />,
    other: <CalendarMonthOutlinedIcon fontSize="inherit" />,
    default: <CalendarMonthOutlinedIcon fontSize="inherit" />,
  };
  const formatDate = (date) =>
    new Date(date).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return (
          <FontAwesomeIcon icon={faCheckCircle} style={{ color: "#059669" }} />
        );
      case "rejected":
        return (
          <FontAwesomeIcon icon={faTimesCircle} style={{ color: "#DC2626" }} />
        );
      default:
        return (
          <FontAwesomeIcon
            icon={faHourglassHalf}
            style={{ color: "#f39c12" }}
          />
        );
    }
  };

  const getSubmissionTimestamp = (request) => {
    if (request?.createdAt) {
      const createdAtMs = new Date(request.createdAt).getTime();
      if (!Number.isNaN(createdAtMs)) return createdAtMs;
    }

    // Fallback for schemas without timestamps: ObjectId contains creation time.
    const objectId = request?._id;
    if (typeof objectId === "string" && objectId.length >= 8) {
      const hexSeconds = objectId.substring(0, 8);
      const seconds = parseInt(hexSeconds, 16);
      if (!Number.isNaN(seconds)) return seconds * 1000;
    }

    return 0;
  };

  const sortedLeaveRequests = [...leaveRequests].sort(
    (a, b) => getSubmissionTimestamp(b) - getSubmissionTimestamp(a)
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: "#F8FAFC",
      }}
    >
      <Navbar />
      <Box sx={{ display: "flex", flex: 1 }}>
        <Sidebar />
        <Box component="main" sx={{ flex: 1, p: 2, ml: { sm: 0, md: 2 } }}>
   {/* 1. Header */}
<Box
  sx={{
    // maxWidth: "1100px",
    mx: "auto",
    display: "flex",
    flexWrap: "wrap", // ✅ allows wrapping when space is tight
    flexDirection: { xs: "column", md: "row" }, // ✅ stacks earlier
    justifyContent: "space-between",
    alignItems: "center",
    gap: 2,
    mt: { xs: 6, md: 8 },
    mb: 4,
    // px: { xs: 1, sm: 2 },
  }}
>
  {/* Left: Title & Subtitle */}
  <Box sx={{ flexGrow: 1, minWidth: 220 }}>
    <Typography
      variant="h4"
      fontWeight="bold"
      sx={{
        color: "#0f172a",
        fontSize: { xs: "1.5rem", sm: "2rem" },
        whiteSpace: "nowrap", // ✅ prevents breaking mid-word
      }}
    >
      My Leave Requests
    </Typography>
    <Typography
      variant="body2"
      sx={{ color: "#64748b", fontSize: { xs: "0.875rem", sm: "1rem" } }}
    >
      Apply for leave and track your requests
    </Typography>
  </Box>

  {/* Right: Button */}
  <Box sx={{ flexShrink: 0, minWidth: { xs: "100%", sm: "auto" } }}>
    <button
      onClick={() => navigate("/ApplyForLeave")}
      style={{
        backgroundColor: "#000",
        color: "#fff",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "6px 14px",
        borderRadius: "6px",
        border: "none",
        cursor: "pointer",
        fontWeight: 600,
        fontSize: "14px",
        transition: "all 0.2s ease-in-out",
        width: "100%",
        maxWidth: "160px",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#1f2937";
        e.currentTarget.style.transform = "scale(1.03)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "#000";
        e.currentTarget.style.transform = "scale(1)";
      }}
    >
      <FontAwesomeIcon icon={faPlus} style={{ marginRight: "6px" }} />
      {!isMobile && "Apply Leave"}
    </button>
  </Box>
</Box>



{remainingLeaves && (
  <Box 
    sx={{ 
      width: "100%",       // Full width so it can adapt
      mx: "auto", 
      mb: 4, 
      // px: { xs: 1,  } // Padding adjusts for small screens
    }}
  >
    <Typography variant="h6" fontWeight={600} mb={0.5}>
      Remaining Leaves
    </Typography>

    <Grid container spacing={2}>
      {Object.entries(remainingLeaves.remainingLeave || {}).map(
        ([type, count]) => {
          const icon =
            leaveIcons[type.toLowerCase()] || leaveIcons.default;

          return (
            <Grid 
              item 
              xs={12}    // full width on extra small
              sm={6}     // two per row on small
              md={3}     // four per row on medium+
              key={type}
            >
              <Paper
                sx={{
                  p: { xs: 1.5, sm: 2 },
                  minWidth: 200, // prevents cards from shrinking too much
                  borderRadius: 2,
                  height: "100%",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Box>
                  <Typography
                    variant="subtitle2"
                    color="#2c3e50"
                    fontWeight={500}
                    sx={{ fontSize: { xs: "0.85rem", sm: "1rem" } }}
                  >
                    {type
                      .replace(/([a-z])([A-Z])/g, "$1 $2")
                      .replace(/^./, (str) => str.toUpperCase())}
                  </Typography>
                  <Typography 
                    variant="h5" 
                    fontWeight="bold" 
                    sx={{ fontSize: { xs: "1.5rem", sm: "1.75rem" } }}
                  >
                    {count}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    color="text.secondary" 
                    sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                  >
                    days available
                  </Typography>
                </Box>

                <Box sx={{ color: "#2563eb", fontSize: { xs: "28px", sm: "35px" } }}>
                  {icon}
                </Box>
              </Paper>
            </Grid>
          );
        }
      )}
    </Grid>
  </Box>
)}


          <Paper
            elevation={0}
            sx={{
              borderRadius: 3,
              boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
              p: 3,
            }}
          >
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Leave Requests
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={3}>
              Manage leave requests from your team
            </Typography>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr 1fr",
                color: "#475569",
                fontWeight: 600,
                fontSize: "14px",
                px: 1,
                mb: 1,
              }}
            >
              <Box>Type</Box>
              <Box>Period</Box>
              <Box>Days</Box>
              <Box>Status</Box>
            </Box>

            {sortedLeaveRequests.map((req, index) => (
              <Box
                key={req._id}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr 1fr",
                  alignItems: "center",
                  px: 1,
                  py: 1.25,
                  borderRadius: 2,
                  backgroundColor: "#fff",
                  transition: "background 0.2s",
                  borderBottom:
                    index !== sortedLeaveRequests.length - 1
                      ? "1px solid #e5e7eb"
                      : "none",
                  "&:hover": {
                    backgroundColor: "#f9fafb",
                  },
                }}
              >
                <Typography
                  variant="body2"
                  fontWeight={500}
                  fontSize="14px"
                  sx={{ textTransform: "capitalize" }}
                >
                  {req.leaveType}
                </Typography>

                <Box>
                  <Typography variant="body2" fontWeight={500} fontSize="14px">
                    {formatDate(req.startDate)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    to {formatDate(req.endDate)}
                  </Typography>
                </Box>

                <Typography fontSize="14px">
                  {calculateLeaveDays(req.startDate, req.endDate)}
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {getStatusIcon(req.status)}
                  <Box
                    sx={{
                      backgroundColor:
                        req.status === "approved"
                          ? "#d1fae5"
                          : req.status === "rejected"
                          ? "#fee2e2"
                          : "#fef9c3",
                      color:
                        req.status === "approved"
                          ? "#065f46"
                          : req.status === "rejected"
                          ? "#991b1b"
                          : "#92400e",
                      px: 1.5,
                      py: 0.3,
                      borderRadius: "999px",
                      fontSize: "13px",
                      fontWeight: 500,
                      textTransform: "capitalize",
                      boxShadow: "0px 1px 2px rgba(0,0,0,0.05)",
                    }}
                  >
                    {req.status || "pending"}
                  </Box>
                </Box>
              </Box>
            ))}
          </Paper>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default LeaveRequestsList;




